import { render } from "./PlantList.vue?vue&type=template&id=7fa4340c&scoped=true&ts=true"
import script from "./PlantList.vue?vue&type=script&lang=ts"
export * from "./PlantList.vue?vue&type=script&lang=ts"

import "./PlantList.vue?vue&type=style&index=0&id=7fa4340c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa4340c"]])

export default __exports__